import { render, staticRenderFns } from "./Laureat.vue?vue&type=template&id=4191ddb6"
import script from "./Laureat.vue?vue&type=script&lang=js"
export * from "./Laureat.vue?vue&type=script&lang=js"
import style0 from "./Laureat.vue?vue&type=style&index=0&id=4191ddb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports